const menu = [
  
  {
    heading: "Product Catalog",
  },
  {
    icon: "list-thumb-fill",
    text: "Product Catalog",
    link: "/product-catalogue",
  },
  {
    icon: "upload",
    text: "Bulk update - Product Details",
    link: "/bulk-update",
  },
  
  {
    heading: "Orders",
  },
  {
    icon: "file-docs",
    text: "Purchase Orders",
    link: "/invoice-listing",
  },
  {
    icon: "file-docs",
    text: "Payments",
    link: "/invoice-upload-listing",
  },
  {
    heading: "Help Center",
  },
  {
    icon: "chat-circle",
    text: "Help Center",
    link: "/help-center",
  },
  {
    heading: "Your Business Overview",
  },
  
  {
    icon: "chart",
    text: "Revenue Report",
    link: "/order-revenue",
  },
  {
    icon: "chart",
    text: "Cancellations And Returns",
    link: "/order-return-cancel",
  },
  
  {
    icon: "chart",
    text: "Delays and Quality Check Report",
    link: "/order-inward",
  },
  
  {
    icon: "chart",
    text: "Consignment Report",
    link: "/purchase-order",
  },
];
export default menu;
